import i18next from "i18next";
import { create } from "zustand";

import type { Language } from "../../utils/enums";
import type { GeneralState } from "./general-store.types";

export const useGeneralStore = create<GeneralState>(set => ({
  language: i18next.resolvedLanguage as Language,
  currentTimezone: "",
  isAddingGuest: false,
  isConfirmationPage: false,
  currentStep: 0,
  onNext: undefined,
  onPrev: undefined,
  reset: undefined,
  setLanguage: language =>
    set(() => ({
      language,
    })),

  setCurrentTimezone: timezone =>
    set(() => ({
      currentTimezone: timezone,
    })),

  setOnNext: callback =>
    set(() => ({
      onNext: callback,
    })),
  setOnPrev: callback =>
    set(() => ({
      onPrev: callback,
    })),

  setOnReset: callback =>
    set(() => ({
      reset: callback,
    })),

  setCurrentStep: step =>
    set(() => ({
      currentStep: step,
    })),

  showAddGuestForm: () =>
    set(() => ({
      isAddingGuest: true,
    })),

  hideAddGuestForm: () =>
    set(() => ({
      isAddingGuest: false,
    })),

  setIsConfirmationPage: payload =>
    set(() => ({
      isConfirmationPage: payload,
    })),
}));
